import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { executeQuery } from "./api";
import { MdxQueryRequest, QueryResult } from "./types";
import type { RootState } from "../../app/store";
import { CUBE_NAME } from "./cubeSlice";

interface ResultsState {
  data: QueryResult | null; // { rows: any[][], columns: string[] }
  loading: boolean;
  error: string | null;
}
const initialState: ResultsState = { data: null, loading: false, error: null };
export const runQuery = createAsyncThunk<QueryResult>(
  "results/runQuery",
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const { query } = state;
      const request: MdxQueryRequest = {
        cubeName: CUBE_NAME,
        measures: query.measures,
        rows: query.rows,
        columns: query.columns,
        dateFrom: query.dateFrom || undefined,
        dateTo: query.dateTo || undefined,
        // Totaux calculés par SSAS (lignes / colonnes « All »), jamais dans le front
        includeTotals: true,
      };
      const response = await executeQuery(request);
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err?.response?.data?.message ?? err.message ?? "Erreur",
      );
    }
  },
);
const resultsSlice = createSlice({
  name: "results",
  initialState,
  reducers: {
    clearResults: (state) => {
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(runQuery.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(runQuery.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(runQuery.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) ?? action.error.message ?? "Query failed";
      });
  },
});

export const { clearResults } = resultsSlice.actions;
export default resultsSlice.reducer;
